import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import API from "@/lib/api";
import { Badges } from "@/components/Badges";
import { ArrowLeft, Star, MapPin, Clock, Award } from "lucide-react";

export default function PublicProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  useEffect(() => { API.get(`/users/${id}/public`).then((r) => setP(r.data)).catch(() => {}); }, [id]);
  if (!p) return <Layout><p className="text-[#4A4E68]">Caricamento...</p></Layout>;

  return (
    <Layout>
      <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1 text-[#4A4E68] mb-3 text-sm"><ArrowLeft size={16} /> Indietro</button>
      <div className="bg-white rounded-[18px] border border-[#DADFEA] p-5">
        <div className="flex items-center gap-3">
          <div className="w-14 h-14 rounded-full bg-[#1F4FE0] text-white flex items-center justify-center text-xl font-semibold">{(p.name || "?")[0]}</div>
          <div>
            <h1 className="font-serif text-xl font-bold text-[#0F1230]">{p.name}</h1>
            <p className="text-sm text-[#4A4E68]">{p.type === "business" ? "Attività" : p.type === "service_person" ? "Persona che offre servizi" : "Utente"}{p.city ? ` · ${p.city}` : ""}</p>
          </div>
        </div>
        <div className="mt-3"><Badges badges={p.badges || []} /></div>

        <div className="flex flex-wrap gap-4 mt-4 text-sm text-[#2A2E48]">
          {p.avg_rating != null && <span className="inline-flex items-center gap-1"><Star size={15} className="fill-[#FFB800] text-[#FFB800]" /> {p.avg_rating} ({p.review_count})</span>}
          <span className="inline-flex items-center gap-1"><Award size={15} /> Scelto {p.chosen_count} volte</span>
          {p.languages?.length > 0 && <span>Lingue: {p.languages.join(", ").toUpperCase()}</span>}
        </div>

        {p.description && <p className="text-[#2A2E48] mt-4">{p.description}</p>}
        {p.bio && <p className="text-[#2A2E48] mt-4">{p.bio}</p>}
        {p.registry?.order && <p className="text-sm text-[#4A4E68] mt-2">{p.registry.order} · n. {p.registry.number}</p>}
        {p.hours && <p className="text-sm text-[#4A4E68] mt-1 inline-flex items-center gap-1"><Clock size={13} /> {p.hours}</p>}
        {p.type === "business" && p.public_contacts && (
          <div className="mt-3 text-sm text-[#2A2E48]">
            {p.public_contacts.phone && <p>Tel: {p.public_contacts.phone}</p>}
            {p.public_contacts.email && <p>Email: {p.public_contacts.email}</p>}
          </div>
        )}
      </div>

      {p.reviews?.length > 0 && (
        <div className="mt-5">
          <h2 className="font-serif text-xl font-semibold text-[#0F1230] mb-3">Recensioni</h2>
          <div className="space-y-2">
            {p.reviews.map((rv) => (
              <div key={rv.id} className="bg-white rounded-[18px] border border-[#DADFEA] p-4">
                <div className="flex items-center gap-0.5 text-[#FFB800] mb-1">
                  {Array.from({ length: rv.rating }).map((_, i) => <Star key={i} size={14} className="fill-[#FFB800]" />)}
                </div>
                <p className="text-sm text-[#2A2E48]">{rv.comment}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </Layout>
  );
}
